import __request__ from "routing/request";
export function changeFieldType(request, requestOptions) {
  return __request__("PUT", "/system/indices/mappings", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeCustomMapping(request, requestOptions) {
  return __request__("PUT", "/system/indices/mappings/remove_mapping", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeProfileFromIndexSets(request, requestOptions) {
  return __request__("PUT", "/system/indices/mappings/remove_profile_from", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setProfile(request, requestOptions) {
  return __request__("PUT", "/system/indices/mappings/set_profile", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAllFieldTypes(requestOptions) {
  return __request__("GET", "/system/indices/mappings/types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
